import React from 'react';

function HealthCheck() {
  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      healthy
    </div>
  );
}

export default HealthCheck;